(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );


  /* DEKATO stable desktop mega-menu hover */
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const items = Array.from(document.querySelectorAll('.dekato-main-item--has-mega'));
    if (!items.length) return;

    let closeTimer = null;

    const closeAll = (except = null) => {
      items.forEach((item) => {
        if (item !== except) item.classList.remove('is-open');
      });
    };

    const openItem = (item) => {
      if (!desktopQuery.matches) return;
      window.clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
    };

    const scheduleClose = (item) => {
      if (!desktopQuery.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        item.classList.remove('is-open');
      }, 220);
    };

    items.forEach((item) => {
      const trigger = item.querySelector(':scope > .dekato-main-link');
      const panel = item.querySelector(':scope > .dekato-mega-panel');
      if (!trigger || !panel) return;

      trigger.setAttribute('aria-haspopup', 'true');

      item.addEventListener('mouseenter', () => openItem(item));
      item.addEventListener('mouseleave', () => scheduleClose(item));

      panel.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        openItem(item);
      });

      trigger.addEventListener('focus', () => openItem(item));

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) {
          scheduleClose(item);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    desktopQuery.addEventListener('change', () => {
      window.clearTimeout(closeTimer);
      closeAll();
    });
  })();

  /* DEKATO touch-friendly mobile visual menu */
  (() => {
    const mobileMenu = document.querySelector('.dekato-mobile-menu');
    if (!mobileMenu) return;

    const closeButton = mobileMenu.querySelector('.dekato-mobile-menu__close');
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    const syncBodyLock = () => {
      document.body.classList.toggle('dekato-mobile-menu-open', mobileMenu.open && mobileQuery.matches);
    };

    mobileMenu.addEventListener('toggle', syncBodyLock);

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        mobileMenu.open = false;
        syncBodyLock();
        const trigger = mobileMenu.querySelector(':scope > summary');
        if (trigger) trigger.focus();
      });
    }

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        document.body.classList.remove('dekato-mobile-menu-open');
      });
    });

    mobileQuery.addEventListener('change', () => {
      if (!mobileQuery.matches) mobileMenu.open = false;
      syncBodyLock();
    });
  })();

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
